module.exports = __webpack_public_path__ + "img/confirmed-verify.00f3ba3c.png";